export default "__VITE_ASSET__25783299__"